export default __webpack_public_path__ + "static/media/School Program - Class 11.58a1ee4f.jpg";